
// ROUTES
require('modules/user/routes/user');

// CONTROLLERS
require('modules/user/controllers/user');
require('modules/user/controllers/list');
require('modules/user/controllers/create');
require('modules/user/controllers/edit');

// SERVICES
require('modules/user/services/user');
require('modules/user/services/list');
require('modules/user/services/create');
require('modules/user/services/edit');
require('modules/user/services/delete');


angular.module('unica_user', [

	// ROUTES
	'unica_user.user_routes',

	// CONTROLLERS
	'unica_user.user_controllers',

	// SERVICES
	'unica_user.user_services'

]);